import React, { useCallback, useMemo } from "react";
import { Table } from "reactstrap";
import numeral from "numeral";
import { LISA } from "types";

const excludes = [
  "changed_by_fk",
  "changed_on",
  "created_by_fk",
  "created_on",
  "id",
  "is_active",
  "month_year",
  "month_year_start_date",
  "site_id",
  "version",
];

type RowItemProps = {
  row: LISA.IFRSLeaseResultApiData;
  keys: Array<string>;
};

const RowItem = ({ row, keys }: RowItemProps) => {
  return (
    <tr>
      <td>
        <div>{row.month_year.split("-")[0]}</div>
      </td>
      <td>
        <div>{row.month_year.split("-")[1]}</div>
      </td>
      {keys.map((k) => (
        <td key={k}>
          <div className="content-end">{numeral(row[k]).format("0,0")}</div>
        </td>
      ))}
    </tr>
  );
};

type IFRSLeaseTableProps = {
  data: Array<LISA.IFRSLeaseResultApiData>;
};

const IFRSLeaseTable = ({ data }: IFRSLeaseTableProps) => {
  const keys = useMemo(() => {
    return Object.keys(data?.[0] || {}).filter((k) => !excludes.includes(k));
  }, [data]);
  const renderRow = useCallback((row: LISA.IFRSLeaseResultApiData) => {
    return <RowItem row={row} key={row.id} keys={keys} />;
  }, [keys]);

  return (
    <Table responsive striped style={{ marginTop: 10 }}>
      <thead>
        <tr>
          <th>
            <div className="table-header">
              <span>Year</span>
            </div>
          </th>
          <th>
            <div className="table-header">
              <span>Month</span>
            </div>
          </th>
          {keys.map((k) => (
            <th key={k}>
              <div
                className="table-header"
                style={{ textTransform: "capitalize" }}
              >
                <span>{k.replaceAll("_", " ")}</span>
              </div>
            </th>
          ))}
        </tr>
      </thead>
      <tbody>{data.map(renderRow)}</tbody>
    </Table>
  );
};

export default IFRSLeaseTable;
